import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { CommonResponse } from "../interfaces/home";
import { SupplierServ } from "../interfaces/supplier";

@Injectable({
  providedIn: "root",
})
export class SupplierServiceService {
  baseUrl = environment.baseUrl + "SupplierService/";
  //baseUrl = "https://localhost:44344/api/v1/SupplierService/";

  constructor(private http: HttpClient) {}

  getAll(): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(this.baseUrl);
  }

  getByID(id: number): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(this.baseUrl + id);
  }

  create(data: SupplierServ): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(this.baseUrl, data);
  }

  delete(id: number) {
    return this.http.delete(this.baseUrl + id);
  }

  update(id: any, data: SupplierServ): Observable<CommonResponse> {
    return this.http.put<CommonResponse>(this.baseUrl + id, data);
  }
}
